import React, { Fragment } from 'react';

import useAthleteEntry from './UseAthleteEntry';

import AthleteEntryGrid from './AthleteEntryGrid';
import DeleteOmeModalInfo from '../../myMeets/meetHost/DeleteOmeModalInfo';

import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SecondaryButton from '@usas/ui-web/components/buttons/SecondaryButton';
import Headings from '@usas/ui-web/components/headings/Headings';
import Input from '@usas/ui-web/components/inputs/Input';
import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';
import ReportPeriodDropdown from '@usas/ui-web/components/dropdowns/reportPeriodDropdown/ReportPeriodDropdown';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import YesNoSwitch from '@usas/ui-web/components/yesNoSwitch/YesNoSwitch';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

import Constants from '@usas/ui-web/utils/Constants';

const AthleteEntry = () => {
  const {
    formState,
    errorState,
    modalState,
    omeMeetAthleteEntryState,
    onFormValueChanged,
    onValueTextPairChanged,
    omeMeetAthleteEntryStatusState,
    USAS_ORGANIZATION_ID,
    onCreateEntryClicked,
    onEditEntryClicked,
    onViewEntryClicked,
    onDeleteEntryClicked,
    onDeleteAthleteEntry,
    onFilterClicked,
    onClearFilterClicked,
    onModalCanceled,
    displayLoadingPopUp
  } = useAthleteEntry();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>My Athlete Meet Entries</Headings.H3>
        </div>
      </div>
      <form>
        <div className='row'>
          <div className='col-xs-12 col-sm-6 col-md-3'>
            <Input
              label="Meet Name"
              name="meetName"
              value={formState.meetName}
              error={errorState.meetName}
              message={errorState.meetName}
              onChange={(value) => { onFormValueChanged('meetName', value); }}
            />
          </div>
          <div className='col-xs-12 col-sm-6 col-md-3'>
            <Dropdown
              label="Athlete Entry Status"
              name="athleteEntryStatusId"
              options={omeMeetAthleteEntryStatusState}
              value={formState.athleteEntryStatusId}
              error={errorState.athleteEntryStatusId}
              message={errorState.athleteEntryStatusId}
              isLoading={false}
              onChange={(value) => { onFormValueChanged('athleteEntryStatusId', value); }} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <ReportPeriodDropdown
              label="Registration Year"
              name="reportPeriodId"
              value={formState.reportPeriodId}
              error={errorState.reportPeriodId}
              message={errorState.reportPeriodId}
              onChange={(newValue, newValueLabel) =>
                onValueTextPairChanged(newValue, 'reportPeriodId', newValueLabel, 'reportPeriodName')}
              organizationId={USAS_ORGANIZATION_ID}
              defaultOption={true}
              currentAndFutureOptionsOnly={false} />
          </div>
          <div className="col-xs-12 col-sm-6 col-md-3">
            <YesNoSwitch
              label="Future Meet?"
              name="isCurrent"
              checked={formState.isCurrent}
              error={errorState.isCurrent}
              message={errorState.isCurrent}
              onChange={(value) => { onFormValueChanged('isCurrent', value) }} />
          </div>
          <div className='col-xs-6 col-sm-2 col-md-1'>
            <button className={global.PlainButton} onClick={(e) => onFilterClicked(e)}>Filter</button>
          </div>
          <div className='col-xs-6 col-sm-4 col-md-2'>
            <button className={global.PlainButton} onClick={(e) => onClearFilterClicked(e)}>Clear Filter</button>
          </div>
        </div>
      </form>
      <div className='row usas-extra-top-margin'>
        <div className='col-xs-12'>
          <AthleteEntryGrid
            state={omeMeetAthleteEntryState}
            onCreate={onCreateEntryClicked}
            onEdit={onEditEntryClicked}
            onDeleteClicked={onDeleteEntryClicked}
            onView={onViewEntryClicked}
          />
        </div>
      </div>
      <PopUpModal
        widthPct={90}
        maxWidth={720}
        title={modalState.modalTitle}
        displayPopUp={modalState.displayPopUp}
        onModalCanceled={onModalCanceled}>
        <div className="row">
          <div className='col-xs-12'>
            <p><strong>OME Meet Name:</strong> {modalState?.omeMeetName}</p>
            <DeleteOmeModalInfo modalState={modalState} />
            <p><strong>Athlete:</strong> {modalState?.athleteName} ({modalState?.athleteCompetitionCategory}, {modalState?.athleteAgeAtMeet})</p>
            <p><strong>Athlete Birth Date:</strong> {modalState?.athleteBirthDate}</p>
            <p><strong>Athlete Entry Status:</strong> {modalState?.athleteEntryStatus}</p>
            <p><strong>Team Name:</strong> {modalState?.orgUnitName}</p>
          </div>
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="button" onClick={(e) => onDeleteAthleteEntry(e, modalState.orgUnitAthleteEntryId)}>Delete</PrimaryButton>&nbsp;
            <SecondaryButton type="button" onClick={onModalCanceled}>Cancel</SecondaryButton>
          </div>
        </div>
      </PopUpModal>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={displayLoadingPopUp}
      />
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.SAVING_MSG}
        displayPopUp={omeMeetAthleteEntryState.isSaving}
      />
    </Fragment>
  );
};

export default AthleteEntry;